export const STUDY_PROGRAM_IDS = [
  'rd-ready-rd-exam',
  'rd-ready-cnsc-prep',
] as const

export type StudyProgramId = (typeof STUDY_PROGRAM_IDS)[number]

export type StudyProgram = {
  id: StudyProgramId
  name: string
  shortName: string
  priceCents: number
  stripePriceId?: string
  lookupKey?: string
}

export const STUDY_PROGRAMS: Record<StudyProgramId, StudyProgram> = {
  'rd-ready-rd-exam': {
    id: 'rd-ready-rd-exam',
    name: 'RD Exam Prep',
    shortName: 'RD Exam',
    priceCents: 15000,
    stripePriceId: 'price_1TsWFUKm05ta39B3K5liP6mi',
  },
  'rd-ready-cnsc-prep': {
    id: 'rd-ready-cnsc-prep',
    name: 'CNSC Exam Prep',
    shortName: 'CNSC Exam',
    priceCents: 15000,
    lookupKey: 'rd_ready_cnsc_prep',
  },
}

export function isStudyProgramId(
  value: string | null,
): value is StudyProgramId {
  return Boolean(value && STUDY_PROGRAM_IDS.includes(value as StudyProgramId))
}

export function getStudyProgram(value: string | null): StudyProgram | null {
  return isStudyProgramId(value) ? STUDY_PROGRAMS[value] : null
}

export function getStudyUrl(programId: StudyProgramId): string {
  return `/study?product=${programId}`
}

export function getCheckoutUrl(
  programId: StudyProgramId,
  state?: 'success' | 'cancelled',
): string {
  const query = new URLSearchParams({ product: programId })
  if (state) query.set('state', state)
  return `/checkout?${query.toString()}`
}
